export default "__VITE_ASSET__DZmLSEBc__"